import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { RegistComponent } from './pages/regist/regist.component';
import { RegisterAccountComponent } from './components/register-account/register-account.component';
import { RecoverAccountComponent } from './pages/recover-account/recover-account.component';
import { RecoverComponent } from './components/recover/recover.component';
import { LoginComponent } from './components/login/login.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { SharedModule } from '../shared/shared.module';
import { AuthService } from '../core/services/auth.service';
import { ChangePwComponent } from './pages/change-pw/change-pw.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ModalCondicionesComponent } from './components/modal-condiciones/modal-condiciones.component';
import { MatDialogModule } from '@angular/material/dialog';
import { RecaptchaFormsModule, RecaptchaModule } from "ng-recaptcha";
import { ModalRecoverComponent } from './components/modal-recover/modal-recover.component';
import { AuthFooterComponent } from './components/auth-footer/auth-footer.component';
import { RegisterExpressRetailComponent } from './pages/register-express-retail/register-express-retail.component';
import { ExpressRetailFormComponent } from './components/express-retail-form/express-retail-form.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ExpressFullMensajeComponent } from './components/express-full-mensaje/express-full-mensaje.component';
import { ModalAvisoComunasComponent } from './components/modal-aviso-comunas/modal-aviso-comunas.component';

@NgModule({
  declarations: [
    AuthComponent,
    CarouselComponent,
    RegistComponent,
    RegisterAccountComponent,
    RecoverAccountComponent,
    RecoverComponent,
    LoginComponent,
    SignInComponent,
    SignUpComponent,
    ChangePwComponent,
    ChangePasswordComponent,
    ModalCondicionesComponent,
    ModalRecoverComponent,
    AuthFooterComponent,
    RegisterExpressRetailComponent,
    ExpressRetailFormComponent,
    ExpressFullMensajeComponent,
    ModalAvisoComunasComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    CarouselModule.forRoot(),
    SharedModule,
    MatDialogModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NgbTooltipModule,
  ],
  providers: [
    AuthService,
  ]
})
export class AuthModule { }
